import { useState, useEffect } from "react";
import Sidebar from "./sidebar/Sidebar";
import axios from "axios";
import api from "../api/axios";
import Select from "react-select";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
function AddnewProject() {
  const location = useLocation();
  const dataToEdit = location.state?.data;
  const navigate = useNavigate();
  const [sidebarToggle, setSidebarToggle] = useState(true);
  const [projectid, setProjectid] = useState("");
  const [batchid, setBatchid] = useState("");
  const [projectname, setProjectname] = useState("");
  const [methodology, setMethodology] = useState("");
  const [avalableCredits, setAvalableCredits] = useState("");
  const [price, setPrice] = useState("");
  const [address, setAddress] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [pincode, setPincode] = useState("");
  const [locationURL, setLocationURL] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [projectDescription, setProjectDescription] = useState("");
  const [nFT, setNFT] = useState("");
  const [projectimage, setProjectimage] = useState([]);
  const [featureimg, setfeatureimg] = useState("");
  const [registryimage, setRegistryimage] = useState("");
  const [goalsImage, setGoalsImage] = useState([]);
  const [removel, setRemovel] = useState("");
  const [selectMethodology, setSelectMethodology] = useState([]);
  const [selectCarbon, setSelectCarbon] = useState([]);
  const [country, setCountry] = useState("");
  const [vintagedetails, setVintagedetails] = useState([
    {
      id: 1,
      Vintage: "",
      BatchId: "",
      CreditID: "",
      Credits: "",
      CreditsPrice: "",
    },
  ]);

  const [howworkdetails, setHowworkdetails] = useState([
    { id: 1, label: "", Description: "" },
  ]);

  const [socialbenefitdetails, setSocialbenefitdetails] = useState([
    { id: 1, icon: "", Description: "" },
  ]);
  const [keypointdetails, setKeypointdetails] = useState([
    { id: 1, Section: "", Description: "" },
  ]);

  const countries = [
    { label: "🇮🇳 India", value: "India" },
    { label: "🇺🇸 United States", value: "United States" },
    { label: "🇬🇧 United Kingdom", value: "United Kingdom" },
    { label: "🇦🇺 Australia", value: "Australia" },
    { label: "🇨🇦 Canada", value: "Canada" },
    { label: "🇸🇬 Singapore", value: "Singapore" },
    { label: "🇦🇪 United Arab Emirates", value: "United Arab Emirates" },
    { label: "🇩🇪 Germany", value: "Germany" },
    { label: "🇫🇷 France", value: "France" },
    { label: "🇳🇵 Nepal", value: "Nepal" },
    { label: "🇵🇰 Pakistan", value: "Pakistan" },
    { label: "🇧🇩 Bangladesh", value: "Bangladesh" },
    { label: "🇱🇰 Sri Lanka", value: "Sri Lanka" },
    { label: "🇿🇦 South Africa", value: "South Africa" },
    { label: "🇯🇵 Japan", value: "Japan" },
  ];


  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: "6px",
      borderColor: state.isFocused ? "#2563eb" : "#d1d5db",
      boxShadow: state.isFocused ? "0 0 0 1px #2563eb" : "none",
      minHeight: "30px",
      height: "30px",
      fontSize: "14px",
      padding: "0 4px",
      "&:hover": {
        borderColor: "#2563eb",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 4px",
      height: "30px",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0px",
      padding: "0px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "30px",
    }),
    option: (provided) => ({
      ...provided,
      fontSize: "14px",
      padding: "6px 10px",
      display: "flex",
      alignItems: "center",
      gap: "8px",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  //sidebar toggle
  const toggleClick = () => {
    setSidebarToggle(!sidebarToggle);
  };

  // logic for vintage
  const handleVintageEvent = () => {
    const newRow = {
      id: vintagedetails.length + 1,
      Vintage: "",
      BatchId: "",
      CreditID: "",
      Credits: "",
      CreditsPrice: "",
    };
    setVintagedetails([...vintagedetails, newRow]);
  };

  const handleVintageInputChange = (e, id, field) => {
    const value = e.target.value;
    setVintagedetails((prevsection) =>
      prevsection.map((section) =>
        section.id === id ? { ...section, [field]: value } : section
      )
    );
  };

  const handleVintageCancleRow = (id) => {
    setVintagedetails((prevsection) =>
      prevsection.filter((section) => section.id !== id)
    );
  };

  // logic for how it works
  const hanlehowWorkevent = () => {
    const newRow = {
      id: howworkdetails.length + 1,
      label: "",
      Description: "",
    };
    setHowworkdetails([...howworkdetails, newRow]);
  };

  const handleWorkInputChange = (e, id, field) => {
    const value = e.target.value;
    setHowworkdetails((prevSections) =>
      prevSections.map((section) =>
        section.id === id ? { ...section, [field]: value } : section
      )
    );
  };

  const handleworkCancleRow = (id) => {
    const updateHowitsWork = howworkdetails.filter((section) => section.id !== id);
    setHowworkdetails(updateHowitsWork);
  };

  // logic for social benefits
  const handlesocialbenefitclickevent = () => {
    const newRow = {
      id: socialbenefitdetails.length + 1,
      icon: "",
      Description: "",
    };
    setSocialbenefitdetails([...socialbenefitdetails, newRow]);
  };

  const handlebenefitInputChange = (e, id, field) => {
    const { value, files } = e.target;
    setSocialbenefitdetails((prevSections) =>
      prevSections.map((section) =>
        section.id === id
          ? { ...section, [field]: field === "icon" ? files[0] : value }
          : section
      )
    );
  };

  const handlebenefitCancleRow = (id) => {
    const updatedata = socialbenefitdetails.filter((section) => section.id !== id)
    setSocialbenefitdetails(updatedata)
  };

  // logic for key points
  const handlekeypointevent = () => {
    const newRow = {
      id: keypointdetails.length + 1,
      Section: "",
      Description: "",
    };
    setKeypointdetails([...keypointdetails, newRow]);
  };

  const handlekeypointInputChange = (e, id, field) => {
    const value = e.target.value;
    setKeypointdetails((prevSections) =>
      prevSections.map((section) =>
        section.id === id ? { ...section, [field]: value } : section
      )
    );
  };

  const handlekeypointCancleRow = (id) => {
    const updatedata = keypointdetails.filter((section) => section.id !== id)
    setKeypointdetails(updatedata)
  };

  useEffect(() => {
    if (dataToEdit) {
      setProjectid(dataToEdit.projectid || "");
      setBatchid(dataToEdit.batchid || "");
      setProjectname(dataToEdit.projectname || "");
      setMethodology(dataToEdit.methodology || "");
      setAvalableCredits(dataToEdit.avalableCredits || "");
      setPrice(dataToEdit.price || "");
      setAddress(dataToEdit.address || "");
      setState(dataToEdit.state || "");
      setCity(dataToEdit.city || "");
      setPincode(dataToEdit.pincode || "");
      setLocationURL(dataToEdit.locationURL || "");
      setLatitude(dataToEdit.latitude || "");
      setLongitude(dataToEdit.longitude || "");
      setRemovel(dataToEdit.removel || "")
      setCountry(dataToEdit.country || "")
      setProjectimage(dataToEdit.projectimage || "");
      setGoalsImage(dataToEdit.goalsImage || "");
      setfeatureimg(dataToEdit.featureimg || "");
      setNFT(dataToEdit.nFT || "");
      setProjectDescription(dataToEdit.projectDescription || "");
      setRegistryimage(dataToEdit.registryimage || "");
      setVintagedetails(dataToEdit.vintagedetails || "");
      setHowworkdetails(dataToEdit.howworkdetails || "");
      setSocialbenefitdetails(dataToEdit.socialbenefitdetails || "");
      setKeypointdetails(dataToEdit.keypointdetails || "");
    }
  }, [dataToEdit]);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const formdata = new FormData();
      formdata.append("projectid", projectid);
      formdata.append("batchid", batchid);
      formdata.append("projectname", projectname);
      formdata.append("methodology", methodology);
      formdata.append("avalableCredits", avalableCredits);
      formdata.append("price", price);
      formdata.append("address", address);
      formdata.append("state", state);
      formdata.append("city", city);
      formdata.append("pincode", pincode);
      formdata.append("locationURL", locationURL);
      formdata.append("latitude", latitude);
      formdata.append("longitude", longitude);
      formdata.append("removel", removel);
      formdata.append("country", country);
      projectimage.forEach((files) => {
        formdata.append("projectimage", files);
      })
      goalsImage.forEach((files) => {
        formdata.append("goalsImage", files)
      })
      formdata.append("featureimg", featureimg);
      formdata.append("nFT", nFT);
      formdata.append("projectDescription", projectDescription);
      formdata.append("registryimage", registryimage);
      formdata.append("vintagedetails", JSON.stringify(vintagedetails));
      formdata.append("howworkdetails", JSON.stringify(howworkdetails));
      // ✅ SEND socialbenefitdetails with EXISTING icon URL
      formdata.append(
        "socialbenefitdetails",
        JSON.stringify(
          socialbenefitdetails.map(item => ({
            id: item.id,
            Description: item.Description,
            icon: item.icon instanceof File ? null : item.icon
          }))
        )
      );

      socialbenefitdetails.forEach((item) => {
        if (item.icon instanceof File) {
          formdata.append("icon", item.icon);
          formdata.append("icon_id", item.id);
        }
      });
      formdata.append("keypointdetails", JSON.stringify(keypointdetails));

      if (dataToEdit) {

        await api.put(
          `/putproject/${dataToEdit._id}`,
          formdata,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        toast.success("Project Edit successfully");
      } else {
        await api.post("/setproject", formdata, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        toast.success("Project added successfully");
      }
      navigate("/project");
    } catch (error) {
      console.error(error);
    }
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setProjectimage(files);
  };

  const handleGoalImageChange = (e) => {
    const files = Array.from(e.target.files);
    setGoalsImage(files);
  };

  const fetchmethodology = async () => {
    const res = await api.get("/getmethodology");
    setSelectMethodology(res.data)
  }

  const fetchcarbon = async () => {
    const res = await api.get("/getcarbon");
    setSelectCarbon(res.data)
  }

  useEffect(() => {
    fetchmethodology()
    fetchcarbon()
  }, [])

  const DeleteProjectImage = async (imageid, projectid) => {
    try {
      await api.delete(`/deleteprojectimage/${imageid}/${projectid}`);
      toast.success("Project image deleted successfully")
      navigate("/project");
    } catch (error) {
      console.error("Error deleting project image:", error);
    }
  };

  const DeleteDevelopmentgoalImage = async (imageid, projectid) => {
    try {
      await api.delete(`/deletegoalImage/${imageid}/${projectid}`);
      toast.success("goal image deleted successfully")
      navigate("/project");
    } catch (error) {
      console.error("Error deleting goal image:", error);
    }
  };


  return (
    <>
      {/* header section-1 */}
      <div className="font-[Poppins] flex ">
        {sidebarToggle ? <div className="w-[320px] nirav"></div> : ""}
        <Sidebar toggleClick={toggleClick} sidebarToggle={sidebarToggle} />
        <div className="w-[100%] ">
          <div className=" 2xl:w-[90%] w-[95%] m-auto 2xl:mt-16 mt-10  xl:p-2 lg:p-10  p-2">
            <div className="sm:flex sm:justify-between sm:items-center">
              <h1 className="font-medium 2xl:text-2xl text-xl">
                Hello AbsorbX 👋🏼
              </h1>
            </div>

            {/* section-3 */}
            <div className="border mt-5 2xl:rounded-[30px] rounded-[20px] px-10 py-8  bg-white shadow-sm">
              <div className=" flex flex-wrap justify-between items-center">
                <div className="mb-3">
                  <h1 className="font-semibold 2xl:text-2xl text-xl">
                    {dataToEdit ? "Edit Project" : "Add New Project"}
                  </h1>
                </div>
              </div>
              {/* section-4 */}
              <section className="mt-4">
                <form
                  onSubmit={handleFormSubmit}
                  className="flex flex-col gap-10"
                  action=""
                >
                  {/* project details */}
                  <div className="border p-4 flex flex-col gap-4 border-[#ECECEC] rounded-xl">
                    <h4 className="text-[#202020] text-sm pb-3 border-b font-semibold border-[#ECECEC]">
                      Project Details
                    </h4>
                    <div className="grid grid-cols-3 gap-4">
                      <div>
                        <label className="text-[#202020] text-sm" htmlFor="">
                          Project ID
                        </label>
                        <br />
                        <input
                          className="border rounded-md text-sm px-3 py-1 w-full"
                          placeholder="Enter product ID"
                          type="text"
                          value={projectid || ""}
                          onChange={(e) => setProjectid(e.target.value)}
                        />
                      </div>
                      {/* <div>
                        <label className="text-[#202020] text-sm" htmlFor="">
                          Batch ID
                        </label>
                        <br />
                        <input
                          className="border rounded-md text-sm px-3 py-1 w-full"
                          placeholder="Enter batch id"
                          type="text"
                          value={batchid}
                          onChange={(e) => setBatchid(e.target.value)}
                        />
                      </div> */}
                      <div>
                        <label className="text-[#202020] text-sm" htmlFor="">
                          Project Name
                        </label>
                        <br />
                        <input
                          className="border rounded-md text-sm px-3 py-1 w-full"
                          placeholder="Enter Project Name"
                          type="text"
                          value={projectname || ""}
                          onChange={(e) => setProjectname(e.target.value)}
                        />
                      </div>
                      <div>
                        <label className="text-[#202020] text-sm" htmlFor="">
                          Credits Available
                        </label>
                        <br />
                        <input
                          className="border rounded-md text-sm px-3 py-1 w-full"
                          placeholder="Enter Credits Available"
                          type="number"
                          value={avalableCredits || ""}
                          onChange={(e) => setAvalableCredits(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-3 gap-4">
                      <div>
                        <label className="text-[#202020] text-sm" htmlFor="">
                          Credit Price
                        </label>
                        <br />
                        <input
                          className="border rounded-md text-sm px-3 py-1 w-full"
                          placeholder="Enter Credit Price"
                          type="number"
                          value={price || ""}
                          onChange={(e) => setPrice(e.target.value)}
                        />
                      </div>
                      <div>
                        <label className="text-[#202020] text-sm" htmlFor="">
                          Methodology
                        </label>
                        <br />
                        <select
                          value={methodology || ""}
                          onChange={(e) => setMethodology(e.target.value)}
                          className="border rounded-md text-sm px-3 py-[0.20rem] w-full"
                          name=""
                          id=""
                        >
                          <option value="">--Select Item--</option>
                          {selectMethodology.map((data, index) => (
                            <option key={index} value={data.methodology}>{data.methodology}</option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label className="text-[#202020] text-sm" htmlFor="">
                          Carbon removal
                        </label>
                        <br />
                        <select
                          value={removel || ""}
                          onChange={(e) => setRemovel(e.target.value)}
                          className="border rounded-md text-sm px-3 py-[0.20rem] w-full"
                          name=""
                          id=""
                        >
                          <option value="">--Select Item--</option>
                          {selectCarbon.map((data, index) => (
                            <option key={index} value={data.carbon}>{data.carbon}</option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label className="text-[#202020] text-sm" htmlFor="">
                          Address
                        </label>
                        <br />
                        <input
                          className="border rounded-md text-sm px-3 py-1 w-full"
                          placeholder="Enter Methodology"
                          type="text"
                          value={address || ""}
                          onChange={(e) => setAddress(e.target.value)}
                        />
                      </div>
                      <div>
                        <label className="text-[#202020] text-sm">Country</label>
                        <Select
                          options={countries}
                          value={countries.find((c) => c.value === country)}
                          onChange={(option) => setCountry(option.value)}
                          placeholder="Select Country"
                          styles={customStyles}
                          isSearchable
                        />
                      </div>

                      <div>
                        <label className="text-[#202020] text-sm" htmlFor="">
                          State
                        </label>
                        <br />
                        <input
                          className="border rounded-md text-sm px-3 py-1 w-full"
                          placeholder="Enter State"
                          type="text"
                          value={state || ""}
                          onChange={(e) => setState(e.target.value)}
                        />
                      </div>
                      <div>
                        <label className="text-[#202020] text-sm" htmlFor="">
                          City
                        </label>
                        <br />
                        <input
                          className="border rounded-md text-sm px-3 py-1 w-full"
                          placeholder="Enter City"
                          type="text"
                          value={city || ""}
                          onChange={(e) => setCity(e.target.value)}
                        />
                      </div>
                      <div>
                        <label className="text-[#202020] text-sm" htmlFor="">
                          Pin Code
                        </label>
                        <br />
                        <input
                          className="border rounded-md text-sm px-3 py-1 w-full"
                          placeholder="Enter Pin Code"
                          type="number"
                          value={pincode || ""}
                          onChange={(e) => setPincode(e.target.value)}
                        />
                      </div>
                      <div>
                        <label className="text-[#202020] text-sm" htmlFor="">
                          Latitude
                        </label>
                        <br />
                        <input
                          className="border rounded-md text-sm px-3 py-1 w-full"
                          placeholder="Enter Latitude"
                          type="number"
                          value={latitude || ""}
                          onChange={(e) => setLatitude(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-3 gap-4">

                      <div>
                        <label className="text-[#202020] text-sm" htmlFor="">
                          Longitude
                        </label>
                        <br />
                        <input
                          className="border rounded-md text-sm px-3 py-1 w-full"
                          placeholder="Enter Longitude"
                          type="number"
                          value={longitude || ""}
                          onChange={(e) => setLongitude(e.target.value)}
                        />
                      </div>
                      <div>
                        <label className="text-[#202020] text-sm" htmlFor="">
                          Location URL
                        </label>
                        <br />
                        <input
                          className="border rounded-md text-sm px-3 py-1 w-full"
                          placeholder="Enter Location URL"
                          type="text"
                          value={locationURL || ""}
                          onChange={(e) => setLocationURL(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-3 gap-4"></div>
                    <div className="grid grid-cols-3 gap-4"></div>
                  </div>

                  {/* Vintage */}
                  <div>
                    <div className="border p-4 flex flex-col gap-4 border-[#ECECEC] rounded-xl">
                      <h4 className="text-[#202020] text-sm pb-3 border-b font-semibold border-[#ECECEC]">
                        Vintage
                      </h4>
                      {vintagedetails.map((section) => (
                        <div
                          key={section.id}
                          className="grid grid-cols-6 items-end gap-4"
                        >
                          <div>
                            <label
                              className="text-[#202020] text-sm"
                              htmlFor="Vintage"
                            >
                              Vintage
                            </label>
                            <br />
                            <input
                              className="border rounded-md text-sm px-3 py-1 w-full"
                              placeholder="mm/yyyy"
                              type="text"
                              value={section.Vintage || ""}
                              onChange={(e) =>
                                handleVintageInputChange(
                                  e,
                                  section.id,
                                  "Vintage"
                                )
                              }
                            />
                          </div>
                          <div>
                            <label
                              className="text-[#202020] text-sm"
                              htmlFor=""
                            >
                              Batch Id
                            </label>
                            <br />
                            <input
                              className="border rounded-md text-sm px-3 py-1 w-full"
                              placeholder="Enter Batch Id"
                              type="text"
                              value={section.BatchId || ""}
                              onChange={(e) =>
                                handleVintageInputChange(
                                  e,
                                  section.id,
                                  "BatchId"
                                )
                              }
                            />
                          </div>
                          <div>
                            <label
                              className="text-[#202020] text-sm"
                              htmlFor="CreditID"
                            >
                              Credit ID
                            </label>
                            <br />
                            <input
                              className="border rounded-md text-sm px-3 py-1 w-full"
                              placeholder="Enter Credit ID"
                              type="text"
                              value={section.CreditID || ""}
                              onChange={(e) =>
                                handleVintageInputChange(
                                  e,
                                  section.id,
                                  "CreditID"
                                )
                              }
                            />
                          </div>
                          <div>
                            <label
                              className="text-[#202020] text-sm"
                              htmlFor="Credits"
                            >
                              Credits (tCo2eq)
                            </label>
                            <br />
                            <input
                              className="border rounded-md text-sm px-3 py-1 w-full"
                              placeholder="Enter Credits"
                              type="text"
                              value={section.Credits || ""}
                              onChange={(e) =>
                                handleVintageInputChange(
                                  e,
                                  section.id,
                                  "Credits"
                                )
                              }
                            />
                          </div>
                          <div>
                            <label
                              className="text-[#202020] text-sm"
                              htmlFor="CreditsPrice"
                            >
                              Credits Price
                            </label>
                            <br />
                            <input
                              className="border rounded-md text-sm px-3 py-1 w-full"
                              placeholder="Enter Credits Price "
                              type="number"
                              value={section.CreditsPrice || ""}
                              onChange={(e) =>
                                handleVintageInputChange(
                                  e,
                                  section.id,
                                  "CreditsPrice"
                                )
                              }
                            />
                          </div>
                          <div>
                            <i
                              type="button"
                              onClick={() => handleVintageCancleRow(section.id)}
                              className="fa-regular fa-circle-xmark text-xl text-[#C65B1D] cursor-pointer"
                            ></i>
                          </div>
                        </div>
                      ))}

                      <button
                        type="button"
                        onClick={handleVintageEvent}
                        className="bg-[#F9EFE8] w-[120px] px-4 py-1 text-[#C65B1D] rounded"
                      >
                        Add More
                      </button>
                    </div>
                  </div>

                  {/* About project */}
                  <div className="border p-4 flex flex-col gap-4 border-[#ECECEC] rounded-xl">
                    <h4 className="text-[#202020] text-sm pb-3 border-b font-semibold border-[#ECECEC]">
                      About the Project
                    </h4>
                    <div>
                      <label className="text-[#202020] text-sm" htmlFor="">
                        Description
                      </label>
                      <br />
                      <input
                        className="border rounded-md text-sm px-3 py-1 w-full"
                        placeholder="Enter Description"
                        type="text"
                        value={projectDescription || ""}
                        onChange={(e) => setProjectDescription(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* how it works */}
                  <div>
                    <div className="border p-4 flex flex-col gap-4 border-[#ECECEC] rounded-xl">
                      <h4 className="text-[#202020] text-sm pb-3 border-b font-semibold border-[#ECECEC]">
                        How It Works
                      </h4>
                      {howworkdetails.map((section) => (
                        <div
                          key={section.id}
                          className="grid grid-cols-3 items-end gap-4"
                        >
                          <div>
                            <label
                              className="text-[#202020] text-sm"
                              htmlFor="Label"
                            >
                              Label
                            </label>
                            <br />
                            <input
                              className="border rounded-md text-sm px-3 py-1 w-full"
                              placeholder="Enter label"
                              type="text"
                              value={section.label || ""}
                              onChange={(e) =>
                                handleWorkInputChange(e, section.id, "label")
                              }
                            />
                          </div>
                          <div>
                            <label
                              className="text-[#202020] text-sm"
                              htmlFor=""
                            >
                              Description
                            </label>
                            <br />
                            <input
                              className="border rounded-md text-sm px-3 py-1 w-full"
                              placeholder="Enter Description"
                              type="text"
                              value={section.Description || ""}
                              onChange={(e) =>
                                handleWorkInputChange(
                                  e,
                                  section.id,
                                  "Description"
                                )
                              }
                            />
                          </div>
                          <div>
                            <i
                              type="button"
                              onClick={() => handleworkCancleRow(section.id)}
                              className="fa-regular fa-circle-xmark text-xl text-[#C65B1D] cursor-pointer"
                            ></i>
                          </div>
                        </div>
                      ))}

                      <button
                        type="button"
                        onClick={hanlehowWorkevent}
                        className="bg-[#F9EFE8] w-[120px] px-4 py-1 text-[#C65B1D] rounded"
                      >
                        Add More
                      </button>
                    </div>
                  </div>

                  {/* Social Benefits */}
                  <div>
                    <div className="border p-4 flex flex-col gap-4 border-[#ECECEC] rounded-xl">
                      <h4 className="text-[#202020] text-sm pb-3 border-b font-semibold border-[#ECECEC]">
                        Social Benefits
                      </h4>
                      {socialbenefitdetails.map((section) => (
                        <div
                          key={section.id}
                          className="grid grid-cols-3 items-end gap-4"
                        >
                          <div className="">
                            <p className="text-[#202020] text-sm max-xl:text-xs mb-1">
                              Icon
                            </p>
                            <div className="flex items-center rounded-md border border-gray-300">
                              <input
                                id={`file-${section.id}`}
                                type="file"
                                name="image"
                                className="hidden"
                                // value={section.icon || ""}
                                onChange={(e) =>
                                  handlebenefitInputChange(
                                    e,
                                    section.id,
                                    "icon"
                                  )
                                }
                              />

                              <label
                                htmlFor={`file-${section.id}`}
                                className="flex items-center font-medium text-white text-sm max-xl:text-xs justify-center gap-3 px-4 py-[0.35rem] bg-[#C65B1D] rounded-md shadow cursor-pointer hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:ring-offset-2"
                              >
                                <i className="fa-solid fa-cloud-arrow-up"></i>
                                Upload Icon
                              </label>
                              {section.icon && (
                                <p className="mt-1 text-sm max-xl:text-xs ml-2 text-gray-700 font-medium truncate">
                                  {section.icon.name
                                    ? section.icon.name
                                    : dataToEdit?.socialbenefitdetails
                                      ?.find((item) => item.id === section.id)
                                      ?.icon?.split("-")
                                      .pop()}
                                </p>
                              )}
                            </div>
                          </div>
                          <div>
                            <label
                              className="text-[#202020] text-sm"
                              htmlFor=""
                            >
                              Description
                            </label>
                            <br />
                            <input
                              className="border rounded-md text-sm px-3 py-1 w-full"
                              placeholder="Enter Description"
                              type="text"
                              value={section.Description || ""}
                              onChange={(e) =>
                                handlebenefitInputChange(
                                  e,
                                  section.id,
                                  "Description"
                                )
                              }
                            />
                          </div>

                          <div>
                            <i
                              type="button"
                              onClick={() => handlebenefitCancleRow(section.id)}
                              className="fa-regular fa-circle-xmark text-xl text-[#C65B1D] cursor-pointer"
                            ></i>
                          </div>
                        </div>
                      ))}

                      <button
                        type="button"
                        onClick={handlesocialbenefitclickevent}
                        className="bg-[#F9EFE8] w-[120px] px-4 py-1 text-[#C65B1D] rounded"
                      >
                        Add More
                      </button>

                      <div>
                        <h4 className="text-[#202020] text-sm pb-3 border-b font-semibold border-[#ECECEC]">
                          Development Goals
                        </h4>
                        <div className="flex items-center rounded-md border border-gray-300">
                          <input
                            id="goalimagefile"
                            type="file"
                            name="image"
                            className="hidden"
                            multiple
                            onChange={handleGoalImageChange}
                          />

                          <label
                            htmlFor="goalimagefile"
                            className="flex items-center font-medium text-white text-sm max-xl:text-xs justify-center gap-3 px-4 py-[0.35rem] bg-[#C65B1D] rounded-md shadow cursor-pointer hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:ring-offset-2"
                          >
                            <i className="fa-solid fa-cloud-arrow-up"></i>
                            Upload image
                          </label>
                          {goalsImage.length > 0 && (
                            goalsImage.map((file, index) => (
                              <p key={index} className="mt-1 text-sm max-xl:text-xs ml-2 text-gray-700 font-medium truncate">
                                {file.name ? file.name : ""}
                              </p>
                            ))
                          )}
                        </div>
                        {dataToEdit?.goalsImage?.map((img, index) => (
                          <p key={index} className="flex items-start mt-2 mb-2">
                            {img?.filename || img?.s3Url?.split("/").pop()}
                            <button type="button" onClick={() => DeleteDevelopmentgoalImage(img._id, dataToEdit._id)} className="ml-3"><i class="fa-solid fa-xmark text-red-600 text-base"></i></button>

                          </p>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Standard & Registry */}
                  <div className="border p-4 flex flex-col gap-4 border-[#ECECEC] rounded-xl">
                    <h4 className="text-[#202020] text-sm pb-3 border-b font-semibold border-[#ECECEC]">
                      Standard & Registry
                    </h4>

                    <div className="flex items-center rounded-md border border-gray-300">
                      <input
                        id="imagefile"
                        type="file"
                        name="image"
                        className="hidden"
                        onChange={(e) => setRegistryimage(e.target.files[0])}
                      />

                      <label
                        htmlFor="imagefile"
                        className="flex items-center font-medium text-white text-sm max-xl:text-xs justify-center gap-3 px-4 py-[0.35rem] bg-[#C65B1D] rounded-md shadow cursor-pointer hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:ring-offset-2"
                      >
                        <i className="fa-solid fa-cloud-arrow-up"></i>
                        Upload image
                      </label>

                      {registryimage && (
                        <p className="mt-1 text-sm max-xl:text-xs ml-2 text-gray-700 font-medium truncate">
                          {registryimage.name
                            ? registryimage.name
                            : dataToEdit?.registryimage.split("-").pop()}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Key Points */}
                  <div>
                    <div className="border p-4 flex flex-col gap-4 border-[#ECECEC] rounded-xl">
                      <h4 className="text-[#202020] text-sm pb-3 border-b font-semibold border-[#ECECEC]">
                        Key Points
                      </h4>
                      {keypointdetails.map((section) => (
                        <div
                          key={section.id}
                          className="grid grid-cols-3 items-end gap-4"
                        >
                          <div>
                            <label
                              className="text-[#202020] text-sm"
                              htmlFor="Section"
                            >
                              Section
                            </label>
                            <br />
                            <input
                              className="border rounded-md text-sm px-3 py-1 w-full"
                              placeholder="Enter Section"
                              type="text"
                              value={section.Section || ""}
                              onChange={(e) =>
                                handlekeypointInputChange(
                                  e,
                                  section.id,
                                  "Section"
                                )
                              }
                            />
                          </div>
                          <div>
                            <label
                              className="text-[#202020] text-sm"
                              htmlFor=""
                            >
                              What it covers
                            </label>
                            <br />
                            <input
                              className="border rounded-md text-sm px-3 py-1 w-full"
                              placeholder="Enter section description"
                              type="text"
                              value={section.Description || ""}
                              onChange={(e) =>
                                handlekeypointInputChange(
                                  e,
                                  section.id,
                                  "Description"
                                )
                              }
                            />
                          </div>
                          <div>
                            <i
                              type="button"
                              onClick={() =>
                                handlekeypointCancleRow(section.id)
                              }
                              className="fa-regular fa-circle-xmark text-xl text-[#C65B1D] cursor-pointer"
                            ></i>
                          </div>
                        </div>
                      ))}

                      <button
                        type="button"
                        onClick={handlekeypointevent}
                        className="bg-[#F9EFE8] w-[120px] px-4 py-1 text-[#C65B1D] rounded"
                      >
                        Add More
                      </button>
                    </div>
                  </div>

                  {/* Project Images & NFT */}
                  <div className="grid grid-cols-2 gap-4">
                    <div className="">
                      <p className="text-[#202020] text-sm max-xl:text-xs mb-1">
                        Project Images
                      </p>
                      <div className="flex items-center rounded-md border border-gray-300">
                        <input
                          id="imagfile"
                          type="file"
                          name="image"
                          className="hidden"
                          multiple
                          onChange={handleImageChange}
                        />

                        <label
                          htmlFor="imagfile"
                          className="flex items-center font-medium text-white text-sm max-xl:text-xs justify-center gap-3 px-4 py-[0.35rem] bg-[#C65B1D] rounded-md shadow cursor-pointer hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:ring-offset-2"
                        >
                          <i className="fa-solid fa-cloud-arrow-up"></i>
                          Upload image
                        </label>

                        {projectimage.length > 0 && (
                          projectimage.map((file, index) => (

                            <p key={index} className="mt-1 text-sm max-xl:text-xs ml-2 text-gray-700 font-medium truncate">
                              {file.name
                                ? file.name
                                : ""}
                            </p>

                          ))
                        )}
                      </div>
                      {dataToEdit?.projectimage?.map((img, index) => (
                        <p key={index} className="flex items-start mt-2 mb-2">
                          {img?.filename || img?.s3Url?.split("/").pop()}
                          <button type="button" onClick={() => DeleteProjectImage(img._id, dataToEdit._id)} className="ml-3"><i class="fa-solid fa-xmark text-red-600 text-base"></i></button>
                        </p>
                      ))}
                    </div>

                    <div className="">
                      <p className="text-[#202020] text-sm max-xl:text-xs mb-1">
                        NFT
                      </p>
                      <div className="flex items-center rounded-md border border-gray-300">
                        <input
                          id="nftfile"
                          type="file"
                          name="nft"
                          className="hidden"
                          onChange={(e) => setNFT(e.target.files[0])}
                        />

                        <label
                          htmlFor="nftfile"
                          className="flex items-center font-medium text-white text-sm max-xl:text-xs justify-center gap-3 px-4 py-[0.35rem] bg-[#C65B1D] rounded-md shadow cursor-pointer hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:ring-offset-2"
                        >
                          <i className="fa-solid fa-cloud-arrow-up"></i>
                          Upload image
                        </label>

                        {nFT && (
                          <p className="mt-1 text-sm max-xl:text-xs ml-2 text-gray-700 font-medium truncate">
                            {nFT.name
                              ? nFT.name
                              : dataToEdit?.nFT.split("-").pop()}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="">
                      <p className="text-[#202020] text-sm max-xl:text-xs mb-1">
                        Feature Image
                      </p>
                      <div className="flex items-center rounded-md border border-gray-300">
                        <input
                          id="featurefile"
                          type="file"
                          name="featureimg"
                          className="hidden"
                          onChange={(e) => setfeatureimg(e.target.files[0])}
                        />

                        <label
                          htmlFor="featurefile"
                          className="flex items-center font-medium text-white text-sm max-xl:text-xs justify-center gap-3 px-4 py-[0.35rem] bg-[#C65B1D] rounded-md shadow cursor-pointer hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:ring-offset-2"
                        >
                          <i className="fa-solid fa-cloud-arrow-up"></i>
                          Upload image
                        </label>

                        {featureimg && (
                          <p className="mt-1 text-sm max-xl:text-xs ml-2 text-gray-700 font-medium truncate">
                            {featureimg.name
                              ? featureimg.name
                              : dataToEdit?.featureimg.split("-").pop()}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-end">
                    <button
                      type="submit"
                      className=" px-10 py-1 border rounded-lg bg-[#C65B1D] text-white font-medium"
                    >
                      {dataToEdit ? "Update" : "Save"}
                    </button>
                  </div>
                </form>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddnewProject;
